export const chartOptionsFailureMixin = {
    data: function() {
        return {
            chartOptions: {
                chart: {
                  type: "column",
                  backgroundColor: "transparent",
                  events: {}
                },
                exporting: {
                  enabled: true
                },
                title: {
                  text: "",
                  style: {
                    color: "white",
                    display: "none"
                  }
                },
                subtitle: {
                  text: "Click the bars to view by product group",
                  style: {
                    color: "white",
                    display: "none"
                  }
                },
                xAxis: {
                  type: "category",
                  labels: {
                    style: {
                      color: "white"
                    }
                  }
                },
                yAxis: {
                  title: {
                    text: "Percentage Of Total"
                  }
                },
                legend: {
                  enabled: false
                },
                tooltip: {
                  headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                  pointFormat:
                    "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
                },
                plotOptions: {
                  series: {
                    dataLabels: {
                      enabled: false,
                      format: "{point.name}: {point.y:.1f}%",
                      color: "white",
                      style: {
                        textOutline: false
                      }
                    },
                    point: {
                      events: {
                        click: ({ point }) => {
                          let name = point.name.split("(");
                          this.$router.push("/base/tables/?failure=" +  encodeURIComponent(name[0]) + "&fns_part=" + this.partNum+ '&type='+ this.typeParam +"%287%29");
                        }
                      }
                    }
                  }
                },
                drilldown: {
                  activeAxisLabelStyle: {
                    textDecoration: "none",
                    color: "white"
                  },
                  activeDataLabelStyle: {
                    color: "white"
                  }
                },
                series: [
                  {
                    name: "Info",
                    colorByPoint: true,
                    data: null
                  }
                ]
              }
        }
    }
}
